<script>
import store from "@/utils/store";
import apiHelper from "@/utils/apiHelpers";
import Alert from "@/components/common/alert/AlertView";
import { mapState } from "vuex";

export default {
    name: "login-component",
    data() {
        return {
            data: {
                account_id: "",
                user_name: "",
                password: "",
                otp: "",
            },
            showPassword: false,
            isVerifyOTP: false,
            alert: {
                visible: false,
                type: "",
                message: "",
            },
            asAccount: null,
            headerText: "Customer Account Login",
            logoOnlySrc: require("../../assets/img/logo-only.png"),
            bldgImage: require("../../assets/img/tei-bldg.png"),
        };
    },
    components: {
        Alert,
    },
    computed: {
        ...mapState(["jwtToken", "loggedUser", "isOpenAside"]),
        passwordFieldType() {
            return this.showPassword ? "text" : "password";
        },
        eyeIcon() {
            return this.showPassword ? "eye" : "eye-slash";
        },
    },
    methods: {
        loginAsAccount(asAccount) {
            this.asAccount = asAccount;
            this.data = {
                account_id: "",
                user_name: "",
                password: "",
                otp: "",
            };
        },
        async login() {
            try {
                const response = await apiHelper.login(this.data, this.$router);
                if (response) {
                    await this.$nextTick(); // Wait for reactivity to update
                    if (this.isGuest) {
                        this.$router.push("/");
                        console.log(this.isOpenAside);
                    } else {
                        this.$router.push("/dashboard");
                    }
                }
            } catch (error) {
                if (
                    error.response &&
                    error.response.data &&
                    (error.response.data.message === "Incorrect password" ||
                        error.response.data.message === "User does not exist")
                ) {
                    this.$refs.alert.showAlert(
                        "danger",
                        error.response.data.message,
                    );
                } else {
                    this.$refs.alert.showAlert(
                        "danger",
                        "Something went wrong. Please contact support.",
                    );
                }
            }
        },
        integersOnly(event) {
            const value = this.formatIntegersOnly(event);
            this.data.otp = value;
        },
        backToLogin() {
            this.isVerifyOTP = !this.isVerifyOTP;
        },
        async sendOTP(token) {
            store.commit("setJWTToken", token);
            // const response = await apiHelper.post('/sms', token, this.$router);
            // try {
            //     if (response.success) {
            this.isVerifyOTP = !this.isVerifyOTP;
            //     } else {
            //         throw new Error('Unsuccessful response');
            //     }
            // } catch (error) {
            //     if(error.response && (error.response.data.message =='Incorrect password' || error.response.data.message =='User does not exist')){
            //         this.$refs.alert.showAlert('danger', error.response.data.message);
            //     }else{
            //         this.$refs.alert.showAlert('danger', 'Something went wrong. Please contact support.');
            //         console.log('Login error:', error)
            //     }
            // }
        },
        async verifyOTP() {
            // if(this.data.otp){
            this.getLoggedUser(this.jwtToken);
            // }
        },
        // handleClose(){
        //     this.$router.go(-1);
        // },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
    },
};
</script>
